import { Button, Dialog, Text } from '@applyboard/crystal-ui'

type ConfirmCloseDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onDiscard: () => void
}

export function ConfirmCloseEmailDialog(props: ConfirmCloseDialogProps) {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <Dialog.Heading>Discard email update?</Dialog.Heading>
      <Dialog.Content>
        <Text>
          Closing now will cancel your email update. You can start the process again later.
        </Text>
      </Dialog.Content>
      <Dialog.Actions>
        <Dialog.CloseButton width="fill">Keep editing</Dialog.CloseButton>
        <Button width="fill" intent="negative" onClick={props.onDiscard}>
          Discard changes
        </Button>
      </Dialog.Actions>
    </Dialog>
  )
}
